/**
 * Represents the configuration properties generated from the frontend (JavaScript variables).
 * @type {Object}
 * @property {string} imageClassName - Default MathType formula image class.
 * @property {string} imageClassName - Default MathType CAS image class.
 * @ignore
 */
const jsProperties = {
  imageCustomEditorName: "data-custom-editor",
  imageClassName: "Wirisformula",
  CASClassName: "Wiriscas",
};
export default jsProperties;
